import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  GoogleMap,
  LoadScript,
  Autocomplete,
  Marker,
} from "@react-google-maps/api";
import { GOOGLE_MAP_KEY } from "../../screen/redux/api/Constants";

const GoogleMapPage = ({
  edit,
  setFormData,
  formData,
  latlong,
  searchBarWidth,
  mapHeight,
}) => {
  const center = {
    lat: formData?.lat ? formData?.lat : 13.05321,
    lng: formData?.lng ? formData?.lng : 80.217639,
  };

  const [mapCenter, setMapCenter] = useState(
    latlong?.lat && latlong?.lng ? latlong : center,
  );
  useEffect(() => {
    if (latlong) {
      setMapCenter(latlong);
    }
  }, [latlong]);
  const mapRef = useRef(null);
  const autoCompleteRef = useRef(null);
  const onLoad = useCallback((map) => {
    mapRef.current = map;
    // getAddressFromCoords(center?.lat, center?.lng);
  }, []);

  const onCenterChanged = () => {
    if (!edit) return;
    if (mapRef.current) {
      const newCenter = {
        lat: mapRef.current.getCenter().lat(),
        lng: mapRef.current.getCenter().lng(),
      };
      setMapCenter(newCenter);
      getAddressFromCoords(newCenter?.lat, newCenter?.lng);
      console.log("New center:", newCenter);
    }
  };

  const onAutoCompleteLoad = (autocomplete) => {
    autoCompleteRef.current = autocomplete;
  };

  const onPlaceChanged = () => {
    if (autoCompleteRef.current !== null) {
      const place = autoCompleteRef.current.getPlace();
      if (place.geometry) {
        const newPos = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setMapCenter(newPos);
        console.log("New center2:", newPos);
        getAddressFromCoords(newPos?.lat, newPos?.lng);
        mapRef.current.panTo(newPos);
      }
    }
  };

  const getAddressFromCoords = async (lat, lng) => {
    if (!edit) return;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${GOOGLE_MAP_KEY}`,
      );
      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        setFormData?.((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
          address: data.results[0].formatted_address,
        }));
      } else {
        setFormData?.((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
          address: "No address found.",
        }));
      }
    } catch (error) {
      console.error("Geocoding error:", error);
      setFormData?.((prev) => ({
        ...prev,
        latitude: lat,
        longitude: lng,
        address: "Failed to fetch address.",
      }));
    }
  };

  const mapOptions = {
    fullscreenControl: false, // Hide fullscreen button
    mapTypeControl: false, // Hide map/satellite toggle
    streetViewControl: false, // Hide street view pegman
    zoomControl: false, // Hide zoom in/out buttons
    rotateControl: false, // Hide compass/rotate
    scaleControl: false, // Hide scale bottom left
    clickableIcons: false, // Disable default place icons
    disableDefaultUI: false, // Keep default UI if needed, or true to hide all
  };

  return (
    <div>
      <div>
        <div
          className=""
          style={{
            width: "100%",
            border: "1px solid rgb(179 218 185)",
            position: "relative",
          }}
        >
          {edit && (
            <Autocomplete
              onLoad={onAutoCompleteLoad}
              onPlaceChanged={onPlaceChanged}
              className="d-flex justify-content-center"
            >
              <input
                disabled={!edit}
                type="text"
                placeholder="Search a place"
                style={{
                  width: searchBarWidth ?? "40%",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  fontSize: "16px",
                  outline: "none",
                  zIndex: 1,
                  position: "absolute",
                  margin: "2%",
                }}
              />
            </Autocomplete>
          )}

          <GoogleMap
            mapContainerStyle={{
              width: "100%",
              height: mapHeight ?? "50vh",
            }}
            center={mapCenter}
            zoom={14}
            options={mapOptions}
            onLoad={onLoad}
            // onIdle={onCenterChanged}
            onDragEnd={onCenterChanged}
          >
            <Marker position={mapCenter} />
          </GoogleMap>
        </div>
      </div>
    </div>
  );
};

export default GoogleMapPage;
